export const charities = [
    {
        name: "Animal Wellfare Institute",
        icon: `imgs/awi-logo.svg`,
        url: "https://awionline.org/content/make-donation-awi",
        desc: `Since 1951, the Animal Welfare Institute has been alleviating suffering inflicted on animals by humans. In the early years, AWI founder Christine Stevens sought to end the cruel treatment of animals in experimental laboratories. Inevitably, her work expanded to take on other animal welfare causes such as: abolishing factory farms, preserving species threatened by extinction, and protecting critical habitats.`
    },
    {
        name: `International Fund for Animal Wellfare`,
        icon: `imgs/ifaw-logo.png`,
        url: `https://www.ifaw.org/support`,
        desc: `IFAW (International Fund for Animal Welfare) is a global non-profit helping animals and people thrive together. We are experts and everyday people, working across seas, oceans, and in more than 40 countries around the world. We rescue, rehabilitate, and release animals, and we restore and protect their natural habitats. The problems we’re up against are urgent and complicated. To solve them, we match fresh thinking with bold action. We partner with local communities, governments, non-governmental organizations, and businesses. Together, we pioneer new and innovative ways to help all species flourish. `
    },
    {
        name: `World Wildlife Fund`,
        url: `https://www.worldwildlife.org/pages/ways-to-support-wwf`,
        icon: `imgs/WWF_logo.svg.png`,
        desc: `Our vision is to build a future in which people live in harmony with nature. To deliver this mission, we work to conserve and restore biodiversity, the web that supports all life on Earth; to reduce humanity’s environmental footprint; and to ensure the sustainable use of natural resources to support current and future generations.`
    },
    {
        name: `Animal Wellfare Association`,
        icon: `imgs/awi-logo.png`,
        url: `https://support.awanj.org/donate-now`,
        desc: `AWA’s mission is to eliminate animal suffering, promote the importance of the human-animal bond and improve the role of animals in the well-being of people.`
    }
]

// {
//     name: ``,
//     icon: ``,
//     url: ``,
//     desc: ``
// }
